import React, { useEffect, useState } from "react";
import PopupModal from "../../common/PopupModal";
import "./refreshToken.scss";
import { useDispatch } from "react-redux";
import { fetchMyaccountLogin } from "../../store/Myaccount/myaccountActions";
import { useNavigate } from "react-router-dom";

const RefreshToken = ({ isPopupOpen, closeCallback = () => {} }) => {
  const [isModalOpen, setIsModalOpen] = useState(isPopupOpen);
  const dispatch = useDispatch();
  const navigateTo = useNavigate();

  const handleResetOnClose = () => {
    localStorage.removeItem("auth-key");
    localStorage.removeItem("userName");
    window.location.reload();
    setIsModalOpen(false);
    closeCallback();
    navigateTo("/login");
  };

  useEffect(() => {
    if (isModalOpen) {
      setTimeout(() => {
        handleResetOnClose();
      }, 120000);
    }
  }, [isModalOpen]);

  const handleCloseModal = () => {
    handleResetOnClose();
  };

  const handleFetchToken = () => {
    dispatch(fetchMyaccountLogin()).then(() => {
      setIsModalOpen(false);
      closeCallback();
    });
  };

  const RenderTimeoutContent = () => {
    return (
      <div className="timeout-info-content">
        <div className="row timeout-message">
          <div className="col-md-12">
            <div className="message-container">
              <p className="session-timeout-text">
                Your session will end in 2 minutes due to inactivity
              </p>
              <p className="timeout-text">
                As a security precaution, if your session is idle, the session
                will end and you will be brought to the login page.
              </p>
              <p className="timeout-text">
                If you are still working, click Ok to continue
              </p>
              <div className="button-container">
                <button
                  onClick={handleFetchToken}
                  className="btn ok-btn"
                  aria-label="Close timeout warning"
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="session-timeout-wrapper">
      {isModalOpen && (
        <PopupModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          customRender={RenderTimeoutContent}
          popupType="center"
          width="600px"
        />
      )}
    </div>
  );
};

export default RefreshToken;
